/** Максимальное кол-во загружаемых файлов */
export const MAX_FILE_COUNT = 10;
